import * as React from "react";

import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import {ProjectsEmpty} from "../../../../config/view_const/projects";
import {Company} from "../../../../domain/model/company";
import {Project} from "../../../../domain/model/project";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import EmptyData from "../../../common/organism/empty_data";
import Progress from "../../../common/organism/progress";
import {TBreadcrumbItem, TPagination} from "../../../type/common";
import ClientProjectsMain from "./client_projects_main";
import Faq from "../../faq";

interface IProps {
    isInit: boolean;
    isLoading: boolean;
    projects: Project[];
    projectCount: number;
    companies: Company[];
    paginationPrams: TPagination;
    onCopy: (id: string) => void;
}

const ProjectsComponent: React.FC<IProps> = (props) => {
    const {
        isInit,
        isLoading,
        projects,
        projectCount,
        companies,
        paginationPrams,
        onCopy,
    } = props;

    // 初期化
    if (isInit) {
        return <Progress canAnimation={false}/>;
    }

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientProjects,
    ];

    return (
        <React.Fragment>
            {isLoading && <Progress canAnimation={false}/>}
            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems}/>

                <Faq title={"案件の登録"}
                     text={"案件管理ページから案件を登録できます。テンプレートから画像を選択し、生成AIで案件情報の下書きを作成。その後、必要な編集を行い、すべての項目を入力して公開設定にすることでエントリーやスカウトが可能になります。"}
                     link={
                         "https://branch-saturn-9ef.notion.site/180b91fe393e803492dfd0280b956f06"
                     }/>

                {projectCount === 0 && (
                    <EmptyData
                        main={ProjectsEmpty.projectsForClientMain}
                        description={ProjectsEmpty.projectsForClientDescription}
                    />
                )}
                {projectCount > 0 && (
                    <ClientProjectsMain
                        projects={projects}
                        companies={companies}
                        paginationPrams={paginationPrams}
                        onCopy={onCopy}
                    />
                )}
            </PageWrapper>
        </React.Fragment>
    );
};

export default ProjectsComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/projects/client_projects.tsx